/* Flight Foods cart drawer
   - Every "Add to cart" adds to the existing cart (Shopify AJAX API) instead of replacing it.
   - Opens a slide-out cart instead of redirecting. The header Cart button opens the same drawer.
   - Only active on the Shopify store; on static previews links behave normally. */
(() => {
  const onShopify = !!(window.Shopify && (window.Shopify.shop || window.Shopify.routes));
  if (!onShopify || window.__ffCart) return;
  window.__ffCart = true;

  const ROOT = (window.Shopify.routes && window.Shopify.routes.root) || '/';
  const R = p => ROOT.replace(/\/$/, '') + p;
  const FREE_SHIP = 75;
  const cur = (window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  const money = c => new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format((c || 0) / 100);
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  // If the store's Kaching cart drawer app is installed, use its drawer instead of ours.
  const kaching = () => !!(window.kachingCartApi || window.__kachingCartProps || document.querySelector('kaching-cart, kaching-cart-drawer'));
  const openKaching = () => {
    try { if (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function') return window.kachingCartApi.openCart({ refetchCart: true }); } catch (_) {}
    document.dispatchEvent(new CustomEvent('kaching-cart:open', { detail: { refetchCart: true, timestamp: Date.now() }, bubbles: true, cancelable: true }));
  };
  const img = (u, w) => !u ? '' : u + (u.includes('?') ? '&' : '?') + 'width=' + w;

  /* ---------- styles ---------- */
  const css = `
  .ffc-ov{position:fixed;inset:0;background:rgba(8,7,6,.6);backdrop-filter:blur(3px);opacity:0;pointer-events:none;transition:opacity .35s ease;z-index:9998}
  .ffc{position:fixed;top:0;right:0;height:100%;height:100dvh;width:min(440px,100vw);background:var(--ink-2,#161411);color:var(--text,#f1ebe0);font-family:var(--f-body,system-ui,sans-serif);z-index:9999;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .45s cubic-bezier(.16,1,.3,1);box-shadow:-24px 0 60px rgba(0,0,0,.45);border-left:1px solid var(--line,rgba(241,235,224,.12))}
  .ffc-open .ffc-ov{opacity:1;pointer-events:auto}
  .ffc-open .ffc{transform:none}
  .ffc__head{display:flex;align-items:center;justify-content:space-between;padding:20px 22px;border-bottom:1px solid var(--line,rgba(241,235,224,.12))}
  .ffc__title{margin:0;font-family:var(--f-display,Impact,sans-serif);font-weight:800;text-transform:uppercase;letter-spacing:.04em;font-size:1.5rem}
  .ffc__title span{color:var(--muted,#a79f91);font-family:var(--f-body,sans-serif);font-weight:500;font-size:.9rem;letter-spacing:0;text-transform:none;margin-left:8px}
  .ffc__x{appearance:none;border:1px solid var(--line,rgba(241,235,224,.12));background:transparent;color:inherit;width:40px;height:40px;border-radius:50%;cursor:pointer;display:grid;place-items:center;transition:border-color .2s}
  .ffc__x:hover{border-color:var(--gold,#c9a24a)}
  .ffc__ship{padding:14px 22px;border-bottom:1px solid var(--line,rgba(241,235,224,.12));font-size:.9rem;color:var(--muted,#a79f91)}
  .ffc__ship strong{color:var(--text,#f1ebe0)}
  .ffc__bar{height:6px;border-radius:99px;background:rgba(241,235,224,.1);margin-top:9px;overflow:hidden}
  .ffc__bar span{display:block;height:100%;background:var(--gold,#c9a24a);border-radius:inherit;transition:width .5s cubic-bezier(.16,1,.3,1)}
  .ffc__msg{margin:12px 22px 0;padding:10px 12px;border-radius:8px;background:rgba(201,162,74,.12);color:var(--gold-hi,#e0bd66);font-size:.9rem}
  .ffc__msg.is-err{background:rgba(190,70,60,.15);color:#f0a79d}
  .ffc__list{list-style:none;margin:0;padding:6px 22px;flex:1;overflow-y:auto;overscroll-behavior:contain}
  .ffc__item{display:grid;grid-template-columns:72px 1fr auto;gap:14px;padding:16px 0;border-bottom:1px solid var(--line,rgba(241,235,224,.12));align-items:start}
  .ffc__item.is-new{animation:ffcIn .7s cubic-bezier(.16,1,.3,1)}
  @keyframes ffcIn{from{opacity:0;transform:translateX(18px)}to{opacity:1;transform:none}}
  .ffc__img{width:72px;height:72px;border-radius:10px;background:var(--bone,#efe8dc);object-fit:contain;display:block}
  .ffc__name{margin:0;font-weight:700;font-size:.95rem;line-height:1.3}
  .ffc__name a{color:inherit;text-decoration:none}
  .ffc__meta{margin:3px 0 0;color:var(--muted,#a79f91);font-size:.82rem;line-height:1.35}
  .ffc__plan{color:var(--gold,#c9a24a)}
  .ffc__qty{display:inline-flex;align-items:center;margin-top:10px;border:1px solid var(--line,rgba(241,235,224,.12));border-radius:99px}
  .ffc__qty button{appearance:none;background:none;border:0;color:inherit;width:32px;height:32px;cursor:pointer;font-size:1rem}
  .ffc__qty span{min-width:22px;text-align:center;font-size:.9rem;font-variant-numeric:tabular-nums}
  .ffc__right{text-align:right}
  .ffc__price{margin:0;font-weight:700;font-variant-numeric:tabular-nums}
  .ffc__price s{display:block;color:var(--muted,#a79f91);font-weight:400;font-size:.8rem}
  .ffc__rm{appearance:none;background:none;border:0;color:var(--muted,#a79f91);font-size:.8rem;text-decoration:underline;cursor:pointer;margin-top:12px;padding:0}
  .ffc__rm:hover{color:var(--text,#f1ebe0)}
  .ffc__empty{padding:48px 22px;text-align:center;color:var(--muted,#a79f91)}
  .ffc__empty p{margin:0 0 18px}
  .ffc__foot{padding:18px 22px calc(18px + env(safe-area-inset-bottom));border-top:1px solid var(--line,rgba(241,235,224,.12));background:var(--ink,#0e0d0b)}
  .ffc__row{display:flex;justify-content:space-between;align-items:baseline;margin:0 0 6px;font-size:.92rem;color:var(--muted,#a79f91)}
  .ffc__row--save{color:var(--gold,#c9a24a)}
  .ffc__row--total{color:var(--text,#f1ebe0);font-size:1.1rem;font-weight:700;margin:10px 0 4px}
  .ffc__note{margin:0 0 14px;color:var(--muted,#a79f91);font-size:.8rem}
  .ffc__btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;min-height:52px;border-radius:99px;background:var(--gold,#c9a24a);color:var(--ink,#0e0d0b);font-weight:700;text-decoration:none;font-size:1rem;border:0;cursor:pointer;transition:background .2s}
  .ffc__btn:hover{background:var(--gold-hi,#e0bd66)}
  .ffc__link{display:block;text-align:center;margin-top:12px;color:var(--muted,#a79f91);font-size:.85rem}
  .ffc__link:hover{color:var(--text,#f1ebe0)}
  .ffc.is-busy .ffc__list,.ffc.is-busy .ffc__foot{opacity:.55;pointer-events:none;transition:opacity .2s}
  .ffc-count{display:inline-grid;place-items:center;min-width:20px;height:20px;padding:0 6px;margin-left:6px;border-radius:99px;background:var(--ink,#0e0d0b);color:var(--gold,#c9a24a);font-size:.72rem;font-weight:700;line-height:1}
  .ffc-count[hidden]{display:none}
  .ffc-lock{overflow:hidden}
  @media (prefers-reduced-motion:reduce){.ffc,.ffc-ov,.ffc__bar span{transition:none}.ffc__item.is-new{animation:none}}`;
  const st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* ---------- markup ---------- */
  const wrap = document.createElement('div');
  wrap.innerHTML = `<div class="ffc-ov" data-ffc-close></div>
  <aside class="ffc" role="dialog" aria-modal="true" aria-labelledby="ffcTitle" aria-hidden="true" tabindex="-1">
    <div class="ffc__head"><h2 class="ffc__title" id="ffcTitle">Your cart<span id="ffcN"></span></h2>
      <button type="button" class="ffc__x" data-ffc-close aria-label="Close cart"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>
    <div class="ffc__ship" id="ffcShip" aria-live="polite"></div>
    <div id="ffcMsg" role="status"></div>
    <ul class="ffc__list" id="ffcList"></ul>
    <div class="ffc__foot" id="ffcFoot"></div>
  </aside>`;
  document.body.append(...wrap.childNodes);
  const drawer = document.querySelector('.ffc');
  const $ = id => document.getElementById(id);
  let lastFocus = null, newKeys = new Set();

  function open() {
    lastFocus = document.activeElement;
    document.documentElement.classList.add('ffc-open', 'ffc-lock');
    drawer.setAttribute('aria-hidden', 'false');
    setTimeout(() => drawer.querySelector('.ffc__x').focus(), 60);
  }
  function close() {
    document.documentElement.classList.remove('ffc-open', 'ffc-lock');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', e => { if (e.target.closest('[data-ffc-close]')) close(); });
  document.addEventListener('keydown', e => {
    if (!document.documentElement.classList.contains('ffc-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = [...drawer.querySelectorAll('a[href],button:not([disabled])')];
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  function message(text, err) {
    $('ffcMsg').innerHTML = text ? `<p class="ffc__msg${err ? ' is-err' : ''}">${esc(text)}</p>` : '';
  }

  /* ---------- cart API ---------- */
  const api = (path, body) => fetch(R(path), body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(async r => { const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.'); return j; });

  function badge(count) {
    document.querySelectorAll('[data-ffc-count]').forEach(b => { b.textContent = count; b.hidden = !count; });
  }
  function render(cart) {
    const n = cart.item_count;
    badge(n);
    $('ffcN').textContent = n ? `${n} item${n === 1 ? '' : 's'}` : '';
    const total = cart.total_price, left = FREE_SHIP * 100 - total;
    $('ffcShip').innerHTML = n ? (left > 0 ? `You're <strong>${money(left)}</strong> away from free shipping` : '<strong>You unlocked free shipping.</strong>') + `<div class="ffc__bar"><span style="width:${Math.min(100, total / (FREE_SHIP * 100) * 100)}%"></span></div>` : '';
    $('ffcShip').hidden = !n;
    if (!n) {
      $('ffcList').innerHTML = `<li class="ffc__empty"><p>Your cart is empty.</p><a class="ffc__btn" href="${R('/collections/all')}">Shop all products</a></li>`;
      $('ffcFoot').innerHTML = ''; $('ffcFoot').hidden = true; return;
    }
    $('ffcFoot').hidden = false;
    $('ffcList').innerHTML = cart.items.map(it => {
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<p class="ffc__meta">${esc(it.variant_title)}</p>` : '';
      const plan = it.selling_plan_allocation ? `<p class="ffc__meta ffc__plan">${esc(it.selling_plan_allocation.selling_plan.name)}</p>` : '';
      const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
      return `<li class="ffc__item${newKeys.has(it.key) ? ' is-new' : ''}" data-key="${esc(it.key)}">
        <a href="${esc(it.url)}" tabindex="-1" aria-hidden="true"><img class="ffc__img" src="${esc(img(it.image, 160))}" alt="" width="72" height="72" loading="lazy"></a>
        <div><p class="ffc__name"><a href="${esc(it.url)}">${esc(it.product_title)}</a></p>${variant}${plan}
          <div class="ffc__qty"><button type="button" data-ffc-q="-1" aria-label="Decrease quantity of ${esc(it.product_title)}">\u2212</button><span aria-live="polite">${it.quantity}</span><button type="button" data-ffc-q="1" aria-label="Increase quantity of ${esc(it.product_title)}">+</button></div></div>
        <div class="ffc__right"><p class="ffc__price">${money(it.final_line_price)}${was}</p><button type="button" class="ffc__rm" data-ffc-rm>Remove</button></div>
      </li>`;
    }).join('');
    newKeys = new Set();
    const saved = cart.total_discount || 0;
    const codes = (cart.cart_level_discount_applications || []).map(d => d.title).filter(Boolean);
    $('ffcFoot').innerHTML = `
      ${saved ? `<p class="ffc__row ffc__row--save"><span>Savings${codes.length ? ' (' + esc(codes.join(', ')) + ')' : ''}</span><span>\u2212${money(saved)}</span></p>` : ''}
      <p class="ffc__row ffc__row--total"><span>Subtotal</span><span>${money(total)}</span></p>
      <p class="ffc__note">Shipping and taxes calculated at checkout.</p>
      <a class="ffc__btn" href="${R('/checkout')}">Checkout \u00b7 ${money(total)}</a>
      <a class="ffc__link" href="${R('/cart')}" data-ffc-page>View full cart</a>`;
  }
  const refresh = () => api('/cart.js').then(render);

  async function busy(fn) {
    drawer.classList.add('is-busy');
    try { return await fn(); } finally { drawer.classList.remove('is-busy'); }
  }
  async function applyCode(code) {
    if (!code) return;
    try { await api('/cart/update.js', { discount: code }); }
    catch (e) { await fetch(R('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(R('/cart.js'))), { headers: { Accept: 'application/json' } }).catch(() => {}); }
  }
  function toast(text) {
    let t = document.getElementById('ffcToast');
    if (!t) { t = document.createElement('p'); t.id = 'ffcToast'; t.setAttribute('role', 'alert'); t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;margin:0;padding:12px 18px;border-radius:10px;background:#3a1612;color:#f6d3cd;font:500 14px/1.4 system-ui,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.4);max-width:90vw'; document.body.appendChild(t); }
    t.textContent = text; t.hidden = false; clearTimeout(t._h); t._h = setTimeout(() => { t.hidden = true; }, 5000);
  }
  async function add(items, code, trigger) {
    if (kaching()) {
      trigger && trigger.setAttribute('aria-busy', 'true');
      try {
        await api('/cart/add.js', { items });
        await applyCode(code);
        openKaching();
        api('/cart.js').then(c => badge(c.item_count)).catch(() => {});
      } catch (err) { toast(err.message); }
      finally {
        trigger && trigger.removeAttribute('aria-busy');
        document.querySelectorAll('.is-busy').forEach(el => el !== drawer && el.classList.remove('is-busy'));
      }
      return;
    }
    message('');
    trigger && trigger.setAttribute('aria-busy', 'true');
    open();
    try {
      await busy(async () => {
        const res = await api('/cart/add.js', { items });
        (res.items || []).forEach(i => newKeys.add(i.key));
        await applyCode(code);
        await refresh();
      });
    } catch (err) {
      message(err.message, true);
      refresh().catch(() => {});
    } finally {
      trigger && trigger.removeAttribute('aria-busy');
      document.querySelectorAll('.is-busy').forEach(el => el !== drawer && el.classList.remove('is-busy'));
    }
  }
  window.FFCart = { open: () => { if (kaching()) return openKaching(); open(); refresh(); }, close, add, refresh };

  /* line item quantity / remove */
  drawer.addEventListener('click', e => {
    const li = e.target.closest('.ffc__item'); if (!li) return;
    const q = e.target.closest('[data-ffc-q]'), rm = e.target.closest('[data-ffc-rm]');
    if (!q && !rm) return;
    const now = +li.querySelector('.ffc__qty span').textContent;
    const quantity = rm ? 0 : Math.max(0, now + +q.dataset.ffcQ);
    message('');
    busy(() => api('/cart/change.js', { id: li.dataset.key, quantity }).then(render)).catch(err => message(err.message, true));
  });

  /* ---------- intercept add-to-cart links, cart links and product forms ---------- */
  const PERMA = /\/cart\/(\d+:\d+(?:,\d+:\d+)*)\/?$/;
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]'); if (!a) return;
    if (a.matches('[data-ffc-page]')) return; // "View full cart" goes to the page
    let u; try { u = new URL(a.getAttribute('href'), location.href); } catch (_) { return; }
    if (u.origin !== location.origin) return;
    const m = u.pathname.match(PERMA);
    if (m) {
      e.preventDefault();
      const items = m[1].split(',').map(s => { const [id, q] = s.split(':'); return { id: +id, quantity: +q || 1 }; });
      add(items, u.searchParams.get('discount'), a);
      return;
    }
    if (/\/cart\/?$/.test(u.pathname) && !a.closest('.ffc')) { e.preventDefault(); kaching() ? openKaching() : window.FFCart.open(); }
  }, true);

  document.addEventListener('submit', e => {
    const f = e.target;
    if (!f.matches || !/\/cart\/add\/?$/.test(new URL(f.getAttribute('action') || '', location.href).pathname)) return;
    e.preventDefault();
    const fd = new FormData(f), rows = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^items\[(\d+)\]\[(\w+)\]$/);
      if (m) (rows[m[1]] = rows[m[1]] || {})[m[2]] = v;
    }
    let items = Object.values(rows);
    if (!items.length && fd.get('id')) {
      // standard product form: keep anything an app (Kaching bundles / subscriptions) wrote into it
      const props = {};
      for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && typeof v === 'string') props[m[1]] = v; }
      items = [{ id: fd.get('id'), quantity: fd.get('quantity') || 1, selling_plan: fd.get('selling_plan') || undefined, properties: Object.keys(props).length ? props : undefined }];
    }
    items = items.map(i => { const o = { id: +i.id, quantity: +i.quantity || 1 }; if (i.selling_plan) o.selling_plan = +i.selling_plan; if (i.properties) o.properties = i.properties; return o; });
    const trig = e.submitter || f.querySelector('[type=submit]');
    // optional add-ons (Complete the stack) go in a second request so bundle apps that rewrite the main line leave them alone
    const extra = (f.dataset.extras || '').split(',').filter(Boolean).map(id => ({ id: +id, quantity: 1 }));
    if (!extra.length) { add(items, null, trig); return; }
    (async () => {
      try { await api('/cart/add.js', { items }); } catch (err) { toast(err.message); return; }
      add(extra, null, trig);
    })();
  }, true);

  /* count badge on header cart buttons */
  document.querySelectorAll('.nav__actions a[href$="/cart"], a[data-ffc-cart]').forEach(a => {
    if (a.querySelector('[data-ffc-count]')) return;
    const b = document.createElement('span'); b.className = 'ffc-count'; b.dataset.ffcCount = ''; b.hidden = true; b.setAttribute('aria-label', 'items in cart');
    a.appendChild(b); a.setAttribute('aria-label', 'Open cart');
  });
  refresh().catch(() => {});
  ['kaching-cart:cart-updated', 'kaching-cart:item-added', 'kaching-cart:item-removed'].forEach(ev => document.addEventListener(ev, () => api('/cart.js').then(c => badge(c.item_count)).catch(() => {})));
  addEventListener('pageshow', e => { if (e.persisted) refresh().catch(() => {}); });
})();